import { Pressable as PressableNative } from 'react-native';

// This component is added to support type-safe hover and focus states on web
// https://necolas.github.io/react-native-web/docs/pressable/

export const Pressable = PressableNative;
//# sourceMappingURL=Pressable.js.map